import {
  PLAN_TYPE__EASY_START,
  PLAN_TYPE__BASIC,
  PLAN_TYPE__PRO,
  PLAN_TYPE__BUSINESS,
  SHOPIFY_MODY_APP_URL,
} from 'utils/configs';

export const TITLES = {
  pageTitle: {
    aiPhotoshooting: {
      aiPhotoshootingTitle: 'AI Photo Shooting',
      createStepOne: '1. Choose avatar',
      createStepTwo: '2. Upload cloth image',
      otherPages: 'AI Photo Shooting',
    },
    aiAvatars: {
      aiAvatarsTitle: 'AI Avatars',
      createStepOne: 'Upload your avatar image',
    },
    backgroundRemove: 'Background Remove',
    imageUpscaling: 'Image Upscaling',
    pricing: 'Pricing',
    fashionStore: {
      FSTitle: 'AI Fashion Store',
      FSDescriptionTitle: 'Title:',
      FSDescriptionText: 'Product Description:',
      FSProductInfo: 'Product Info:',
    },
    demo: 'Demo',
    notFound: 'Error 404',
  },
  pageSubtitle: {
    gallery: 'Transfer Tasks',
    create: 'Create',
    details: 'Task Details',
    createBgRemove: 'Pick an image to remove the background',
    createImgUpscaling: 'Upscale image to your composition',
    pricing: 'For custom pricing, please contact us',
    fashionStore: 'Create order and add your images.',
    notFound: 'Page Not Found',
  },
  buttonTitle: {
    addImagesTitle: 'Add images',
    addImagesSubtitle: 'Up to 10 images, max 50 MB each',
    addGalleryImagesSubtitle: 'Up to 10 images',
    addOwnImages: 'Upload from your device',
    addGalleryImages: 'Paste from Mod-y gallery',
    save: 'Save',
    finishOrder: 'Finish',
    publishOrder: 'Publish',
    fashionStore: {
      generateDescription: 'Generate description',
      generatePrice: 'Generate price',
      generateText: 'Generate',
      priceSourcesTitle: 'Price sources',
      completeOrder: 'Complete',
      editDescription: 'Enter manually',
      saveDescription: 'Save',
      saveDisabledTip: 'Please fill in all fields.',
      dropdown1: 'Material',
      dropdown2: 'Cloth type',
      dropdown3: 'Language *',
      goToDetails: 'Edit',
      goToTestTaskDetails: 'Details',
      deleteOrders: 'Delete Order',
    },
  },
  paths: {
    toFSGallery: 'Your Orders',
    toBGGallery: 'Background Remove Tasks',
    toFSNewOrder: 'New Order',
    toFSOrder: 'Order',
    toFSOrderPreview: 'Order Preview',
    globalGallery: 'Global Gallery',
  },
  questions: {
    deleteApproval: 'Are you sure you want to delete it?',
    archiving: 'Are you sure you want to archive it?',
  },
};

export const AUTH_META = {
  introTitle: 'AI platform for online fashion stores',
  introText: 'From Data to Profits — AI That Runs Your Fashion Store.',
  introText2:
    'Upload your clothes, apply virtual avatars, generate product description, handle pricing — all in one, for your brand online.',
  introButtonText: 'Watch Demo',
  introLinkText: 'Schedule a Call',
};

export const MESSAGES = {
  tooManyImagesTitle: 'You are trying to add more than 10 images in total.',
  tooManyImagesText: 'You can add ',
  tooLargeImagesTitle: `Add pictures up to 50 MB each`,
  tooLargeImagesText: `Some of the selected images were too large.
    Images larger than 50 MB were excluded from the list.`,
  notMatchImgFormatTitle: `Add PNG or JPEG images`,
  notMatchImgFormatText: `Allowed image formats are .png and .jpg.
    Pictures with other formats were not added to the list.`,
  maxImagesNumberTitle: `You've added the maximum number of images`,
  maxImagesNumberText: ``,
  noAvatars: 'There are no avatars with the selected parameters',
  askToSelecteAvatar: 'Please, choose avatar.',
  noImages: 'Please add images',
  noTasks: 'There are no tasks here yet.',
  noImageResults: 'There are no image results.',
  dataNotFound: 'Data not found. Please try again',
  serverError: 'Something went wrong. Please reload the page',
  betaLable: [
    'User is responsible for verifying and validating AI generated images.',
    'Image generation results may vary as AI algorithms improve every month.',
    'Please also inform us about possible difficulties in the chat',
  ],
};

export const ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/JPEG',
  'image/JPG',
  'image/PNG',
];

export const SIZES = {
  small: 'XS-S',
  medium: 'M',
  large: 'L-XL',
  smallImage: '70x70',
  largeImage: '400x450',
};

export const AVATAR_SIZES = ['XS-S', 'M', 'L-XL'];

export const MATERIAL_TYPES = [
  'Cotton',
  'Viscose',
  'Linen',
  'Polyester',
  'Atlas',
  'Silk',
];

export const CLOTHES_TYPES = ['T-shirt', 'Dress', 'Pants', 'Jeans', 'Skirt'];

export const DESCRIPTION_LANGUAGES = [
  'arabic',
  'english',
  'french',
  'german',
  'italian',
  'russian',
  'portuguese',
  'spanish',
  'ukrainian',
].sort();

export const RECOMMENDED_PRICE_COUNTRIES = [
  { id: 'country1', country: 'Austria' },
  { id: 'country2', country: 'Belgium' },
  { id: 'country3', country: 'Brazil' },
  { id: 'country4', country: 'Canada' },
  { id: 'country5', country: 'Denmark' },
  { id: 'country6', country: 'Finland' },
  { id: 'country7', country: 'France' },
  { id: 'country8', country: 'Germany' },
  { id: 'country9', country: 'Italy' },
  { id: 'country10', country: 'Netherlands' },
  { id: 'country11', country: 'Norway' },
  { id: 'country12', country: 'Poland' },
  { id: 'country13', country: 'Portugal' },
  { id: 'country14', country: 'Spain' },
  { id: 'country15', country: 'Sweden' },
  { id: 'country16', country: 'Ukraine' },
  { id: 'country17', country: 'United Arab Emirates' },
  { id: 'country18', country: 'United Kingdom' },
  { id: 'country19', country: 'United States' },
].sort((a, b) =>
  a.country.toLowerCase().localeCompare(b.country.toLowerCase())
);

export const CURRENCY_LIST = [
  { id: 'currency1', currency: 'EUR', symbol: '€' },
  { id: 'currency2', currency: 'USD', symbol: '$' },
  { id: 'currency3', currency: 'GBP', symbol: '£' },
  { id: 'currency4', currency: 'UAN', symbol: '₴' },
  { id: 'currency5', currency: 'JPY', symbol: '¥' },
  { id: 'currency6', currency: 'CHF', symbol: '₣' },
  { id: 'currency7', currency: 'CAD', symbol: 'C$' },
  { id: 'currency10', currency: 'PLN', symbol: 'zł' },
  ...[
    { id: 'currency8', currency: 'AUD', symbol: 'A$' },
    { id: 'currency9', currency: 'CNY', symbol: '¥' },
    { id: 'currency11', currency: 'CZK', symbol: 'Kč' },
    { id: 'currency12', currency: 'SEK', symbol: 'kr' },
    { id: 'currency13', currency: 'NOK', symbol: 'kr' },
    { id: 'currency14', currency: 'DKK', symbol: 'kr' },
    { id: 'currency15', currency: 'HUF', symbol: 'Ft' },
    { id: 'currency16', currency: 'TRY', symbol: '₺' },
    { id: 'currency17', currency: 'INR', symbol: '₹' },
    { id: 'currency18', currency: 'BRL', symbol: 'R$' },
    { id: 'currency19', currency: 'ZAR', symbol: 'R' },
    { id: 'currency20', currency: 'KRW', symbol: '₩' },
  ].sort((a, b) =>
    a.currency.toLowerCase().localeCompare(b.currency.toLowerCase())
  ),
];

export const AVATAR_CLOTH_TYPES = ['upper_body', 'lower_body', 'dress'];

export const AVATAR_MATCHING_CLOTH_TYPES_TO_NAMES = {
  upper_body: 'Upper',
  lower_body: 'Lower',
  dress: 'Full',
};

export const MODAL_META = {
  success: {
    title: 'Congratulations!',
    addedImagesTitle: 'Great!',
    message: 'Your images are in processing',
    onCreateOrder: 'Your order is created',
    messageForOrder: 'Images added successfully',
    buttonText: 'Close',
    buttonTextForOrder: 'Continue',
  },
  error: {
    title: 'Error',
    message: 'Sorry, something went wrong, please try again.',
    imageError:
      'Parameters of some images are not appropriate for processing. Allowed: formats png/jpg, max size - 50 MB, max resolution - 5000px',
    buttonText: 'Try again',
  },
  attention: {
    title: 'Attention!',
    message: 'Please, check the previous steps.',
    buttonText: 'Go back',
  },
  assess: {
    question: 'How would you evaluate the result?',
    buttonText: 'Send',
  },
  gratitude: {
    feedback: 'Thank you for your feedback',
  },
  aiGenerateDescription: {
    title: 'Please, choose params to generate a description.',
    tip: 'To generate a description, the order must contain at least one image showing only the clothing (without a person).',
    buttonText: 'AI Generate',
  },
  aiGeneratePrice: {
    title: 'Please, select a country to generate a recommended price.',
    dropdown1: 'Country price search *',
    buttonText: 'AI Generate',
  },
  aboutOwnFiles: {
    title: 'The task must contain images of the same type.',
    message:
      'Click "Continue" to create a task with images from the Mod-y gallery, or "Go back" to use images from your device.',
  },
  subscription: {
    getButton: 'Upgrade Plan',
    buyButton: 'Buy Subscription',
    cancelling: {
      title: 'Are you sure you want to cancel your subscription?',
      confirmButton: 'Cancel Subscription',
      declineButton: 'Keep Plan',
    },
    successRequest: {
      title: 'Thank you!',
      message: 'Plan update request received! Your credits will be added soon.',
      buttonText: 'Ok',
    },
  },
  deletion: {
    title:
      'After deletion, it will be impossible to restore the task. Are you sure you want to delete it?',
    titleForOrders:
      'After deletion, it will be impossible to restore the order(s). Are you sure you want to delete it?',
    confirmButton: 'Delete',
    declineButton: 'Cancel deletion',
  },
  projects: {
    settings: {
      title: 'Project settings',
      nameLable: 'Name',
      namePlaceholder: 'Project name',
      membersTitle: 'Collaborators',
      addButton: 'Add Members',
      inviteButton: 'Invite Members',
      deleteMember: 'Delete',
    },
    deletion: {
      title: 'Are you sure delete your project?',
      note: 'All content of this project will be lost permanently',
      deleteButton: 'Delete project',
      confirmButton: 'Delete permanently',
      declineButton: 'Cancel',
    },
    createWindow: { createButton: 'Create +', createTitle: 'Create project' },
  },
  members: {
    title: 'Members',
    emailPlaceholder: 'Email',
    inviteButton: '+ Invite Member',
    deletion: {
      title: 'Are you sure?',
      note: 'User will be removed from the team',
      deleteMember: 'Delete',
      declineButton: 'Cancel',
    },
  },
  requiredFields: '*Required fields',
};

export const PRICE_LIST = ['Basic', 'Pro', 'Business'];

export const PRICE_META = {
  tariffs: [
    {
      planName: 'Easy Start',
      planType: PLAN_TYPE__EASY_START,
      price: 9,
      credits: 20,
      benefits: [
        'AI Photoshooting',
        'AI Avatars',
        'Image Upscaling',
        'Background Remove',
        'AI Fashion Store',
        {
          benefitIcon: 'shopify',
          text: '',
          linkMeta: { text: 'Shopify', link: SHOPIFY_MODY_APP_URL },
        },
      ],
      buttonText: 'Buy Now',
      infoText: '1 Credit is 1 image generation',
    },
    {
      planName: 'Basic',
      planType: PLAN_TYPE__BASIC,
      price: 49,
      credits: 120,
      benefits: [
        'AI Photoshooting',
        'AI Avatars',
        'Image Upscaling',
        'Background Remove',
        'AI Fashion Store',
        {
          benefitIcon: 'shopify',
          text: '',
          linkMeta: { text: 'Shopify', link: SHOPIFY_MODY_APP_URL },
        },
        'REST API',
        'Support',
      ],
      buttonText: 'Buy Now',
      infoText: '1 Credit is 1 image generation.',
    },
    {
      planName: 'Pro',
      planType: PLAN_TYPE__PRO,
      price: 99,
      credits: 270,
      benefits: [
        'AI Photoshooting',
        'AI Avatars',
        'Image Upscaling',
        'Background Remove',
        'AI Fashion Store',
        {
          benefitIcon: 'shopify',
          text: '',
          linkMeta: { text: 'Shopify', link: SHOPIFY_MODY_APP_URL },
        },
        'REST API',
        'Support',
      ],
      buttonText: 'Buy Now',
      infoText: '1 Credit is 1 image generation.',
    },
    {
      planName: 'Business',
      planType: PLAN_TYPE__BUSINESS,
      price: 'Custom',
      credits: 'Unlimited',
      benefits: [
        'AI Photoshooting',
        'AI Avatars',
        'Image Upscaling',
        'Background Remove',
        'AI Fashion Store',
        {
          benefitIcon: 'shopify',
          text: '',
          linkMeta: { text: 'Shopify', link: SHOPIFY_MODY_APP_URL },
        },
        'REST API',
        'Custom Development by request',
        'Support',
      ],
      buttonText: 'Request a Quote',
      infoText: '1 Credit is 1 image generation.',
    },
  ],

  tables: {
    price: {
      title: '',
      services: [
        { id: 'pricing1', text: 'Price' },
        { id: 'pricing2', text: 'Credits' },
        { id: 'pricing3', text: 'Pricing avatar' },
        { id: 'pricing4', text: 'Hosting' },
        { id: 'pricing5', text: 'REST API' },
      ],
      plan1: {
        title: PRICE_LIST[0],
        services: [
          { id: 'bundle11', text: '49 $' },
          { id: 'bundle12', text: '120' },
          { id: 'bundle13', text: 'Pay-as-You-Go' },
          { id: 'bundle14', text: 'SaaS cloud' },
          { id: 'bundle15', text: 'Yes' },
        ],
      },
      plan2: {
        title: PRICE_LIST[1],
        services: [
          { id: 'bundle21', text: '99 $' },
          { id: 'bundle22', text: '270' },
          { id: 'bundle23', text: 'Pay-as-You-Go' },
          { id: 'bundle24', text: 'SaaS cloud' },
          { id: 'bundle25', text: 'Yes' },
        ],
      },
      plan3: {
        title: PRICE_LIST[2],
        services: [
          { id: 'bundle31', text: 'Custom' },
          { id: 'bundle32', text: 'Unlimited' },
          { id: 'bundle33', text: 'Pay-as-You-Go' },
          { id: 'bundle34', text: 'SaaS cloud, Private cloud, or On-prem' },
          { id: 'bundle35', text: 'Yes' },
        ],
      },
    },
    featurePlan: {
      title: 'Feature plan',
      services: [
        { id: 'feature1', text: 'AI Photoshooting' },
        { id: 'feature5', text: 'AI Avatars' },
        { id: 'feature2', text: 'Image Upscaling' },
        { id: 'feature3', text: 'Background remove' },
        { id: 'feature4', text: 'AI Fashion Store' },
        // { id: 'feature6', text: 'Virtual Try-on' },
        // { id: 'feature7', text: 'AI-Powered Fashion Buying' },
        // { id: 'feature8', text: 'AI uplift avatars for Fashion sell' },
        // { id: 'feature9', text: 'AI Recommendation Systems' },
        // { id: 'feature10', text: 'AI Fashion Stylist' },
        // { id: 'feature11', text: 'AI Cloth Tagging' },
        // { id: 'feature12', text: 'AI Fashion Design 2D&3D' },
        // { id: 'feature13', text: 'AI Materail Fashion Tagging' },
        // { id: 'feature14', text: 'AI Garmet Tailoring and ROS2 Robotics' },
        {
          id: 'feature15',
          text: 'AI Agents platform to Automate Buying, Selling, Customer Support, and Marketing',
        },
        {
          id: 'feature16',
          text: 'AI core platform for AI models (LLMs, VLMs, Tabular, CV)',
        },
      ],
      plan1: {
        title: PRICE_LIST[0],
        services: [
          { id: 'feature11', text: 'Yes' },
          { id: 'feature12', text: 'Yes' },
          { id: 'feature13', text: 'Yes' },
          { id: 'feature14', text: 'Yes' },
          { id: 'feature15', text: 'Yes' },
          // { id: 'feature16', text: '-' },
          // { id: 'feature17', text: '-' },
          // { id: 'feature18', text: '-' },
          // { id: 'feature19', text: '-' },
          // { id: 'feature110', text: '-' },
          // { id: 'feature111', text: '-' },
          // { id: 'feature112', text: '-' },
          // { id: 'feature113', text: '-' },
          // { id: 'feature114', text: '-' },
          { id: 'feature115', text: '-' },
          { id: 'feature116', text: '-' },
        ],
      },
      plan2: {
        title: PRICE_LIST[1],
        services: [
          { id: 'feature21', text: 'Yes' },
          { id: 'feature22', text: 'Yes' },
          { id: 'feature23', text: 'Yes' },
          { id: 'feature24', text: 'Yes' },
          { id: 'feature25', text: 'Yes' },
          // { id: 'feature26', text: '-' },
          // { id: 'feature27', text: '-' },
          // { id: 'feature28', text: '-' },
          // { id: 'feature29', text: '-' },
          // { id: 'feature210', text: '-' },
          // { id: 'feature211', text: '-' },
          // { id: 'feature212', text: '-' },
          // { id: 'feature213', text: '-' },
          // { id: 'feature214', text: '-' },
          { id: 'feature215', text: '-' },
          { id: 'feature216', text: '-' },
        ],
      },
      plan3: {
        title: PRICE_LIST[2],
        services: [
          { id: 'feature31', text: 'Yes' },
          { id: 'feature32', text: 'Yes' },
          { id: 'feature33', text: 'Yes' },
          { id: 'feature34', text: 'Yes' },
          { id: 'feature35', text: 'Yes' },
          // { id: 'feature36', text: 'Available by request' },
          // { id: 'feature37', text: 'Available by request' },
          // { id: 'feature38', text: 'Available by request' },
          // { id: 'feature39', text: 'Available by request' },
          // { id: 'feature310', text: 'Available by request' },
          // { id: 'feature311', text: 'Available by request' },
          // { id: 'feature312', text: 'Available by request' },
          // { id: 'feature313', text: 'Available by request' },
          // { id: 'feature314', text: 'Available by request' },
          { id: 'feature315', text: 'Available by request' },
          { id: 'feature316', text: 'Available by request' },
        ],
      },
    },
    integration: {
      title: 'Integration',
      services: [
        {
          id: 'integration1',
          text: {
            link: SHOPIFY_MODY_APP_URL,
            text: 'Shopify',
            partnerIcon: 'shopify',
          },
        },
        { id: 'integration2', text: 'Third party e-commerce website' },
      ],
      plan1: {
        title: PRICE_LIST[0],
        services: [
          { id: 'integration11', text: 'Yes' },
          { id: 'integration12', text: '-' },
        ],
      },
      plan2: {
        title: PRICE_LIST[1],
        services: [
          { id: 'integration21', text: 'Yes' },
          { id: 'integration22', text: '-' },
        ],
      },
      plan3: {
        title: PRICE_LIST[2],
        services: [
          { id: 'integration31', text: 'Yes' },
          { id: 'integration32', text: 'Available by request' },
        ],
      },
    },
    customizationAndSupport: {
      title: 'Customization and support',
      services: [
        { id: 'customizationAndSupport1', text: 'AI Avatars' },
        { id: 'customizationAndSupport2', text: 'Custom development' },
        {
          id: 'customizationAndSupport3',
          text: 'Custom AI developent and consulting',
        },
        { id: 'customizationAndSupport4', text: 'AI Avatars updates' },
        { id: 'customizationAndSupport5', text: 'Support' },
      ],
      plan1: {
        title: PRICE_LIST[0],
        services: [
          { id: 'customizationAndSupport11', text: 'Standart' },
          { id: 'customizationAndSupport12', text: '-' },
          { id: 'customizationAndSupport13', text: '-' },
          { id: 'customizationAndSupport14', text: 'Yes' },
          { id: 'customizationAndSupport15', text: 'Community support' },
        ],
      },
      plan2: {
        title: PRICE_LIST[1],
        services: [
          { id: 'customizationAndSupport21', text: 'Standart' },
          { id: 'customizationAndSupport22', text: '-' },
          { id: 'customizationAndSupport23', text: '-' },
          { id: 'customizationAndSupport24', text: 'Yes' },
          { id: 'customizationAndSupport25', text: 'Available by request' },
        ],
      },
      plan3: {
        title: PRICE_LIST[2],
        services: [
          { id: 'customizationAndSupport31', text: 'Standart and Custom' },
          {
            id: 'customizationAndSupport32',
            text: 'Available by request',
          },
          { id: 'customizationAndSupport33', text: 'Available by request' },
          { id: 'customizationAndSupport34', text: 'Yes' },
          {
            id: 'customizationAndSupport35',
            text: 'Included up to 10 hours per month',
          },
        ],
      },
    },
  },

  footnotes: [
    { id: 'footnotes1', text: '1 Credit is 1 image generation' },
    {
      id: 'footnotes2',
      text: 'Credits do not accumulate after the end of 30 days after payment is made',
    },
    {
      id: 'footnotes3',
      text: 'Algorithm updates for on-prem and private cloud available by request',
    },
    {
      id: 'footnotes4',
      text: 'All images uploaded to the SaaS could be used for AI training for improvement algorithms but not for public distribution. Please read the privacy policy.',
    },
  ],

  changeTariff: {
    forInformation: 'Your credits will be sum-up.',
    buttonText: 'Update Plan',
    errorText:
      'Oops, something went wrong. Please check your tariff plan and the number of credits and repeat the operation if it`s needed.',
    errorText2: 'Sorry, something went wrong.',
  },
};

export const VIDEO_META = {
  subtitle: 'Create your image in a few clicks',
  subtitleFS: 'Create your order in a few clicks',
};

export const MANAGEMENT_ROLES = ['Owner', 'Admin'];

export const ROLES_TO_ASSIGN = ['Admin', 'Editor', 'Reader'];

export const CURRENCY_SYMBOLS = {
  EUR: { symbol: '€', name: 'European Euro' },
  USD: { symbol: '$', name: 'United States' },
  UAH: { symbol: '₴', name: 'Ukrainian Hryvnia' },
  GBP: { symbol: '£', name: 'British Pound' },
  JPY: { symbol: '¥', name: 'Japanese Yen' },
  CHF: { symbol: '₣', name: 'Swiss Franc' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar' },
  AUD: { symbol: 'A$', name: 'Australian Dollar' },
  CNY: { symbol: '¥', name: 'Chinese Yuan' },
  PLN: { symbol: 'zł', name: 'Polish Złoty' },
  CZK: { symbol: 'Kč', name: 'Czech Koruna' },
  SEK: { symbol: 'kr', name: 'Swedish Krona' },
  NOK: { symbol: 'kr', name: 'Norwegian Krone' },
  DKK: { symbol: 'kr', name: 'Danish Krone' },
  HUF: { symbol: 'Ft', name: 'Hungarian Forint' },
  TRY: { symbol: '₺', name: 'Turkish Lira' },
  INR: { symbol: '₹', name: 'Indian Rupee' },
  BRL: { symbol: 'R$', name: 'Brazilian Real' },
  ZAR: { symbol: 'R', name: 'South African Rand' },
  KRW: { symbol: '₩', name: 'South Korean Won' },
  RON: { symbol: 'lei', name: 'Romanian Leu' },
};
